import styled from 'styled-components';
import { darken } from 'polished';

import PrimitiveModal from '../../../../../../newComponents/Modal';
import { Container as ButtonContainer } from '../../../../../../newComponents/Button/styles';

type GridImageProps = {
  url: string;
  placeholder: string;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 32px 32px;
  font-family: 'Sora', sans-serif;

  @media only screen and (max-width: 768px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  margin-bottom: 25px;

  h2 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 6px;
    color: #101d40;
  }

  p {
    color: #7c8db5;
    font-size: 14px;
  }

  @media only screen and (max-width: 768px) {
    text-align: center;
  }
`;

export const GridsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-wrap: wrap;
  padding: 20px 0;
`;

export const GridItem = styled.li`
  border: 2px solid #e6effb;
  border-radius: 5px;
`;

export const GridImage = styled.div<GridImageProps>`
  background-image: url(${({ placeholder }) => placeholder});
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 38px;
  min-width: 38px;
  height: 38px;
  border: 2px dashed #e6effb;
  border-radius: 5px;
  background-size: cover;

  div {
    height: 38px;
    width: 100%;
    background-image: url(${({ url }) => url}), url(${({ url }) => url});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

export const GridItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 2px solid #e6effb;
  gap: 10px;
`;

export const GridItemBody = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  padding: 10px;

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
`;

export const DeleteButton = styled.button`
  flex: 1;
  background-color: rgba(246, 68, 68, 0.1);
  color: rgb(246, 68, 68);
  padding: 11px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  margin-top: 20px;

  &:hover {
    background-color: rgba(246, 68, 68, 0.3);
  }
`;

export const Modal = styled(PrimitiveModal)`
  display: flex;
  flex-direction: column;

  padding: 28px 32px;
  border-radius: 8px;

  background: #fff;

  overflow-y: auto;
  padding: 20px;
  max-height: 500px;
  height: 100%;

  > p {
    text-align: center;
    margin-top: 10px;
    font-family: 'Sora', sans-serif;
    font-size: 14px;
    color: #7c8db5;
    margin-bottom: 24px;

    strong {
      color: #101d40;
      font-weight: 600;
      margin-top: 5px;
    }
  }

  ${ButtonContainer} {
    & + ${ButtonContainer} {
      margin-top: 10px;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(246, 68, 68, 0.2);
    margin: none;

    svg {
      color: #f64444;
      font-size: 50px;
    }
  }

  h1 {
    color: #101d40;
    font-size: 24px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }

  button {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);

    svg {
      color: #4f4f4f;
      font-size: 22px;
    }

    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  gap: 20px;
  margin: 30px 0 30px;
  flex-wrap: wrap;
  justify-content: center;
  flex: 1;
  align-items: flex-start;
  overflow: auto;
`;

export const HelpButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  font-family: 'Sora', sans-serif;
  font-weight: 500;
  height: 38px;
  background-color: #329bfc;
  color: #ffffff;
  font-size: 18px;
  border: none;
  border-radius: 5px;

  &:hover {
    background-color: ${darken(0.1, '#329bfc')};
  }
`;

export const CloseModalButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgba(215, 222, 233, 0.25);

  svg {
    color: #4f4f4f;
    font-size: 22px;
  }

  &:hover {
    background-color: rgba(215, 222, 233, 0.5);
  }
`;

export const GenerateGridsTable = styled.div`
  width: 100%;
  max-width: 720px;
  margin-top: 15px;
  border: 2px solid #e6effb;
  border-radius: 5px;
`;

export const GenerateGridsTableHeader = styled.div`
  display: flex;

  div {
    flex: 1;
    padding: 15px;
    text-align: center;
    border-bottom: 2px solid #e6effb;
    width: 250px;

    h2 {
      color: #101d40;
      font-size: 16px;
      font-weight: 600;
    }

    &:not(:last-child) {
      border-right: 2px solid #e6effb;
    }
  }
`;

export const GenerateGridsTableBody = styled.div`
  display: flex;

  > div {
    overflow: auto;
    flex: 1;
    height: 350px;

    button {
      background-color: rgb(255, 255, 255);
      display: flex;
      width: 100%;
      border-top: none;
      border-right: none;
      border-left: none;
      border-image: initial;
      outline: none;
      -webkit-box-align: center;
      align-items: center;
      -webkit-box-pack: start;
      justify-content: flex-start;
      text-align: start;
      padding: 12px 10px;
      border-bottom: 1px solid rgb(230, 239, 251);
      color: rgb(16, 29, 64);

      p {
        font-size: 13px;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        margin-left: 8px;
      }

      &:not(:disabled):hover {
        background-color: #eeeeee;
      }

      &.active {
        background-color: #f2f2f2;

        p {
          font-weight: 600;
        }
      }

      &:disabled {
        background-color: rgb(248 248 248);
        cursor: not-allowed;

        p {
          color: #a6a6a6;
        }
      }
    }

    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    &::-webkit-scrollbar-button {
      width: 0px;
      height: 0px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border: 0px none #ffffff;
      border-radius: 50px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a1a1a1;
    }

    &::-webkit-scrollbar-thumb:active {
      background-color: #8a8a8a;
    }

    &::-webkit-scrollbar-track {
      background: #ededed;
      border: 0px none #ffffff;
    }

    &::-webkit-scrollbar-track:hover {
      background: #ededed;
    }

    &::-webkit-scrollbar-track:active {
      background: #ededed;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }

    &:not(:last-child) {
      border-right: 2px solid #e6effb;
    }
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  gap: 5px;
  flex: 1;
  max-width: 720px;
  justify-content: space-around;

  a {
    padding: 4px 8px;
    width: 145px;
  }
`;
